import React from 'react';
import { ShareBox } from 'styled-icons/remix-fill/ShareBox';

export default function ShareBoxIcon(props) {
  const { className } = props;
  const styles = [className, 'icon'];
  return (
    <ShareBox {...props} className={styles} />
  );
}
